import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const createReservation = (payload) =>
  api.post("/reservations", payload).then((r) => r.data);

export const createContactMessage = (payload) =>
  api.post("/contact", payload).then((r) => r.data);

export const getTimeSlots = () =>
  api.get("/reservations/slots").then((r) => r.data?.slots || []);

export const createReview = (payload) =>
  api.post("/reviews", payload).then((r) => r.data);

export const getReviews = (limit = 60) =>
  api.get("/reviews", { params: { limit } }).then((r) => r.data);
